import { render } from "./ChatBotEA.vue?vue&type=template&id=22c131b8&scoped=true"
import script from "./ChatBotEA.vue?vue&type=script&lang=js"
export * from "./ChatBotEA.vue?vue&type=script&lang=js"

import "./ChatBotEA.vue?vue&type=style&index=0&id=22c131b8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22c131b8"]])

export default __exports__